import React, { useEffect, useState } from "react";

import { SPEAK_EASY_CATEGORIES } from "../../../functions/speakEasyCategories";
import { QUESTION_MAX } from "./questionHelpers";

/** Add/Edit question modal from old/admin/editor.php: question text + category. */
export default function QuestionModal({ open, mode, initial, defaultCategory, onClose, onSubmit, isSaving }) {
  const [questionName, setQuestionName] = useState("");
  const [category, setCategory] = useState("");
  const [localError, setLocalError] = useState("");

  const isEdit = mode === "edit";

  useEffect(() => {
    if (!open) return;
    setQuestionName(isEdit ? initial?.question_name || "" : "");
    setCategory(isEdit ? initial?.category || "" : defaultCategory || "");
    setLocalError("");
  }, [open, isEdit, initial, defaultCategory]);

  if (!open) return null;

  const submit = async () => {
    if (!questionName.trim()) {
      setLocalError("Fields cannot be empty!");
      return;
    }
    if (!category) {
      setLocalError("Please select a category.");
      return;
    }
    try {
      await onSubmit({ question_name: questionName.trim(), category });
    } catch {
      /* parent surfaces error */
    }
  };

  return (
    <div className="quiz-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="quiz-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="question-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="quiz-modal-header">
          <h2 id="question-modal-title">{isEdit ? "Edit Question" : "New Question"}</h2>
          <button type="button" className="quiz-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="quiz-modal-body">
          {localError ? <p className="cr-alert cr-alert-error quiz-modal-error">{localError}</p> : null}

          <div className="quiz-modal-field quiz-modal-field--full">
            <label htmlFor="question-modal-text">Question</label>
            <textarea
              id="question-modal-text"
              className="quiz-modal-textarea"
              rows={4}
              value={questionName}
              maxLength={QUESTION_MAX}
              onChange={(e) => {
                setQuestionName(e.target.value);
                setLocalError("");
              }}
              placeholder="Question"
              disabled={isSaving}
            />
            <p className="quiz-modal-limit">Max length {QUESTION_MAX} characters</p>
          </div>

          <div className="quiz-modal-field quiz-modal-field--full">
            <label htmlFor="question-modal-category">Category</label>
            <select
              id="question-modal-category"
              className="quiz-modal-option-count"
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
                setLocalError("");
              }}
              disabled={isSaving}
            >
              <option value="">Select Category</option>
              {SPEAK_EASY_CATEGORIES.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="quiz-modal-footer">
          <button
            type="button"
            className="quiz-modal-btn quiz-modal-btn-save"
            onClick={submit}
            disabled={isSaving}
          >
            <i className="fa-solid fa-cloud-arrow-up" aria-hidden />
            {isSaving ? "Saving…" : isEdit ? "Update" : "Add New Question"}
          </button>
          <button type="button" className="quiz-modal-btn quiz-modal-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
